'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { getThreads } from './getThreads';
export const hasPersistedThreads = createSelector(getThreads, threads => !!threads.size);